export const statusesOfForm = {
  filling: 'filling', sending: 'sending', success: 'success'
}
